// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.73.2/styles/" + "videojs" + ".chunk.css?" + "494b512c31f2cd68a571" + "";
};